import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PhotoViewer from './PhotoViewer';

/**
 * A thumbnail that opens the photograph full size (2026-10-15): the app's one
 * viewer (PhotoViewer), where it is pinched, wheeled, dragged and stepped
 * through with the rest of `photos`, starting at `index`. For the thumbnails
 * that used to open nothing: Field Mode's record and batch editors, the
 * intake form's slots, micrographs on Home, the AI review queue.
 *
 *   photos    PhotoViewer's shape: [{ s3_url, photo_type?, notes?, ... }] --
 *             a blob: or data: URL is fine (a photo still on the phone)
 *   children  the thumbnail itself
 *   label     the button's name, e.g. "Photo 2: Bottom view"; without it,
 *             `dialogLabel` (callers pass the image's own alt there), else
 *             "Open photo" -- the button's name replaces the image's alt
 */
export default function PhotoThumb({ photos, index = 0, children, style, testId, dialogLabel, disabled = false, label }) {
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(null);
  if (disabled || !photos?.length) return children;
  return (
    <>
      <button type="button" onClick={() => setOpen(index)} title={t('tip.photoOpen')} aria-haspopup="dialog"
        aria-label={label || dialogLabel || t('photoViewer.openThis')} data-testid={testId}
        style={{ padding: 0, margin: 0, border: 'none', background: 'none', cursor: 'zoom-in', display: 'block',
          font: 'inherit', color: 'inherit', ...style }}>
        {children}
      </button>
      {open !== null && (
        <PhotoViewer photos={photos} index={open} onIndex={setOpen} onClose={() => setOpen(null)}
          dialogLabel={dialogLabel} />
      )}
    </>
  );
}
